import React from 'react';
import { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { 
    handle_Authenticate, 
    handle_auth_user,
    handle_signedIn, 
    handle_forgotPassword,
} from '../../Redux/reducer';
import {
    handleLogin,
} from '../../Redux/actions';

//DB
import fire from '../../Firebase/fire';

export const SignIn = () => {

  const isSignedIn = useSelector((state) => state.auth.isSignedIn);
  const dispatch = useDispatch();
    
     //Referencing
  const emailRef = useRef();
  const passwordRef = useRef();

  

  function handleSignInSubmit(e) {
    e.preventDefault();
    const user = {
      email: emailRef.current.value,
      password: passwordRef.current.value,
    };
    if (emailRef.current.value == "" || passwordRef.current.value == "") {
      // console.log("SignIn:handleSignInSubmit: Please fill all the fields");
      window.alert("Please fill all the fields to sign in")
    } else {
      // console.log("SignIn:handleSignInSubmit:user = ",user);
      dispatch(handleLogin(user));
      //clear form data on submit
      passwordRef.current.value="";
    }
  }

  //SignUp on enter-press
  const enterSignInPressed = (event) => {
    var code = event.keyCode || event.which;
    if (code === 13) {
      handleSignInSubmit(event);
      //13 is the enter keycode
      //Do stuff in here
    }
  };

    return(
        <div>
            <div className='home-contact-join-form-title'>
                Join us
              </div>
              <form onSubmit={handleSignInSubmit} 
                // onKeyPress={enterSignInPressed}
              >
                <input 
                  className='email2-ip' 
                  placeholder="User E-mail"
                  type="email"
                  required
                  ref={emailRef}
                /><br></br>
                <input 
                  className='pswd-ip' 
                  placeholder="Password"
                  type="password"
                  required
                  ref={passwordRef}
                /><br></br>
                <button className='home-contact-join-submit-btn' type={"submit"}>Sign In</button>
              </form>
              <a className='home-contact-signup-link' 
                onClick={()=>dispatch(handle_forgotPassword(true))}
              > Forgot Password </a>
              <div className='home-contact-signup'>
                Not a member? 
                <a className='home-contact-signup-link' 
                  onClick={()=>dispatch(handle_signedIn(false))}
                > Sign Up </a> 
                now
              </div>
        </div>
    )
}

export default SignIn;